module.exports = __webpack_public_path__ + "img/com_analysis.7cc80cfb.png";